/* eslint-disable import/no-cycle */
import { useMemo } from 'react'

import ForgotPasswordScreen from '../screens/guest/ForgotPasswordScreen'
import LoginScreen from '../screens/guest/LoginScreen'
import ResetPasswordScreen from '../screens/guest/ResetPasswordScreen'

export const useRoutes = () => {
  const routes = useMemo(() => ({
    login: {
      path: '/',
      exact: true,
      Component: LoginScreen
    },
    forgotPassword: {
      path: '/forgot-password',
      exact: true,
      Component: ForgotPasswordScreen
    },
    resetPassword: {
      path: '/auth/reset/',
      exact: true,
      Component: ResetPasswordScreen
    }
  }), [])

  return { routes }
}
